var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrendDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 4,
    fill: "#FFF2F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7188 23.625H12.4062C11.8047 23.625 11.375 23.1953 11.375 22.5938C11.375 22.0352 11.8047 21.5625 12.4062 21.5625H20.2266L10.3008 11.6367C9.87109 11.25 9.87109 10.6055 10.3008 10.1758C10.6875 9.78906 11.332 9.78906 11.7617 10.1758L21.6875 20.1445V12.2812C21.6875 11.7227 22.1172 11.25 22.7188 11.25C23.2773 11.25 23.75 11.7227 23.75 12.2812V22.5938C23.75 23.1953 23.2773 23.625 22.7188 23.625Z",
    fill: "#EF4136"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendDown);
export default __webpack_public_path__ + "static/media/trend-down.ad0d8fae88aa168f150ae3e53ae105b2.svg";
export { ForwardRef as ReactComponent };